








































import { Component, Prop } from "vue-property-decorator";
import DataTable from "@/shared/components/data-table.vue";
import Tooltip from "@/shared/components/tooltip.vue";
import ImagePreview from "@/shared/components/image-preview.vue";
import { dateTimeSeconds, dateTime, cpf } from "@/shared/filters";
import GlobalMixin from "@/shared/mixins/globalMixin";
import { mixins } from "vue-class-component";
import { PromocaoService } from "@/services/promocao.service";

@Component({
  components: {
    DataTable,
    Tooltip,
    ImagePreview
  },
  filters: { dateTimeSeconds, cpf, dateTime },
})
export default class PremiosPromocao extends mixins(GlobalMixin) {
  @Prop() idPromocao!: number;
  urlPremio: string | null = null;
  colocacao = 0;
  premiosPromocao: Promise<any[]> | null = null;
  loading = false;
  selectRow = true;

  headers = [
    { value: "colocacao", text: "Colação" },
    { value: "nome", text: "Nome" },
    { value: "descricao", text: "Descrição" },
    { value: "imagem", text: "Imagem", sortable: false },
    { value: "actions", text: "Ações", sortable: false },
  ];

  mounted() {
    this.fetchUrlPremio();
    this.fetchPremiosPromocao();
  }

  async fetchUrlPremio() {
    this.urlPremio = await PromocaoService.ObterUrlImagemPremio();
  }

  async fetchPremiosPromocao() {
    this.loading = true;
    try {
      const retorno = await PromocaoService.Manter(this.idPromocao!);
      this.premiosPromocao = retorno.premiosPromocao;
      this.colocacao = retorno.premiosPromocao.length;
    } finally {
      this.loading = false;
    }
  }

  async excluirItem(item: any) {
    if (item.idPremioPromocao) {
      await PromocaoService.ExcluirPremio(item.idPremioPromocao);
      this.fetchPremiosPromocao();
    }
  }

  selecionadoPremio(premio: any) {
    this.$router.push({
      name: "promocao-premio",
      params: {
        idPromocao: this.idPromocao + "",
        colocacao: premio.colocacao + "",
        idPremioPromocao: premio.idPremioPromocao,
      },
    });
  }

  novoPremio() {
    if (this.premiosPromocao) {
      this.$router.push({
        name: "promocao-premio",
        params: {
          idPromocao: this.idPromocao + "",
          colocacao: this.colocacao + "",
          idPremioPromocao: "null",
        },
      });
    }
  }

  visualizar(url: string){
    const imagem = this.$refs.imagem as ImagePreview;
    imagem.abrir(url);
  }
}
